export default function SpeckleRefreshButton(p: { onClick(): void }) {
  return (
    <button
      type="button"
      className="inline-flex items-center rounded-full border 
        border-gray-500 bg-white px-1.5 py-1 hover:bg-gray-50"
      onClick={p.onClick}
    >
      Refresh
    </button>
  );
}
